import { useContext, useEffect, useMemo } from 'react';

import { emptyArray } from '../../default-props/empty';
import { Context } from './context';

export const useHotkey = (hotkey) => {
  const { addHotkey, removeHotkey } = useContext(Context);

  useEffect(() => {
    if (!hotkey) {
      return;
    }
    addHotkey(hotkey);

    return () => {
      removeHotkey(hotkey);
    };
  }, [addHotkey, hotkey, removeHotkey]);
};

export const useGlobalHotkeys = () => {
  const { hotkeys = emptyArray } = useContext(Context) || {};

  return useMemo(() => hotkeys.filter((hotkey) => hotkey.isGlobal), [hotkeys]);
};
